import classNames from 'classnames';

import styles from './CircleMark.module.css';

export interface CircleMarkProps {
  checked: boolean;
  isFirst?: boolean;
  isLast?: boolean;
}

export function CircleMark(props: CircleMarkProps) {
  return (
    <span
      aria-hidden
      className={classNames(styles.line, {
        [styles.lineFirst]: props.isFirst,
        [styles.lineLast]: props.isLast,
      })}
    >
      <span
        className={classNames(styles.radio, {
          [styles.checked]: props.checked,
        })}
      />
    </span>
  );
}
